import { render, staticRenderFns } from "./CoreSocialLinks.vue?vue&type=template&id=0d641bce&scoped=true"
import script from "./CoreSocialLinks.vue?vue&type=script&lang=js"
export * from "./CoreSocialLinks.vue?vue&type=script&lang=js"
import style0 from "./CoreSocialLinks.vue?vue&type=style&index=0&id=0d641bce&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d641bce",
  null
  
)

export default component.exports